module.exports = __webpack_public_path__ + "static/media/pickdates.a00fbf02.svg";